import { render } from "./Response.vue?vue&type=template&id=328a2066&scoped=true&ts=true"
import script from "./Response.vue?vue&type=script&lang=ts"
export * from "./Response.vue?vue&type=script&lang=ts"

import "./Response.vue?vue&type=style&index=0&id=328a2066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328a2066"]])

export default __exports__